// Button Spans
const btnsTrig = document.querySelectorAll('.btn--trig');
function formingBtnTrigs(){
  btnsTrig.forEach( function( btn ){
    const initSpan = btn.querySelector('span');
    const btnComputedStyle = window.getComputedStyle(initSpan);
    //const btnOffsetLeft = initSpan.offsetLeft;

    const span = document.createElement("span");
    span.classList.add('btn--trig__base');
    span.style.width = btnComputedStyle.width;
    span.style.height = btnComputedStyle.height;
    //span.style.left = btnOffsetLeft + 'px';

    btn.insertAdjacentElement('afterbegin', span);
  });
}


// Mobile Menu

function mobMenuCalc() {

  const topHead = document.querySelector('#headerTop');
  let winHeight = window.innerHeight;
  let topHeadHeight = topHead.offsetHeight;
  mobHeadMenuHeight = winHeight - topHeadHeight;

  if ( mobMenu.classList.contains('menu--opened') ){
      mobMenu.style.height = mobHeadMenuHeight + 'px';
  } else {
      mobMenu.style.height = '0px';
  }
}

const header = document.querySelector("header");
const mobMenu = document.querySelector('#mobMenu');
const openMobBtn = document.querySelector("#open-close-btn");
/* openMobBtn.addEventListener("click", function(){
  
    if ( mobMenu.classList.contains('menu--opened') ){
        mobMenu.classList.remove('menu--opened');
        mobMenuCalc();
        if( header.classList.contains('normalHeader') ){
            header.classList.remove('shade');
        }
        openMobBtn.classList.remove('menu--opened');

    } else {
        mobMenu.classList.add('menu--opened');
        mobMenuCalc();
        if( header.classList.contains('normalHeader') ){
            header.classList.add('shade');
        }
        openMobBtn.classList.add('menu--opened');
    }
});
 */

const menuControlButtons = document.querySelectorAll('#open-close-btn, .mobMenu-item-link');
menuControlButtons.forEach(menuControlButton => {
  menuControlButton.addEventListener('click', (e) => {
    if ( mobMenu.classList.contains('menu--opened') ){
      mobMenu.classList.remove('menu--opened');
      mobMenuCalc();
      if( header.classList.contains('normalHeader') ){
          header.classList.remove('shade');
      }
      openMobBtn.classList.remove('menu--opened');

    } else {
      mobMenu.classList.add('menu--opened');
      mobMenuCalc();
      if( header.classList.contains('normalHeader') ){
          header.classList.add('shade');
      }
      openMobBtn.classList.add('menu--opened');
    }
  });
});




window.addEventListener("resize", function(){
    const winWidth = window.innerWidth;
    mobMenuCalc();
    if( winWidth >= 1024 ){
        mobMenu.classList.remove('menu--opened');
        openMobBtn.classList.remove('menu--opened');

        if( header.classList.contains('normalHeader') ){
            header.classList.remove('shade');
        }
    }
});



// Smooth jump to anchors
const anchorLinks = document.querySelectorAll('a[href^="#"]');
anchorLinks.forEach(anchorLink => {
    anchorLink.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = anchorLink.getAttribute('href').slice(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth'
            });
        }
    });
});



// Initial Loading
const mobTextFirst = document.querySelectorAll('.mob-text-first');
window.addEventListener("DOMContentLoaded", function(){
  formingBtnTrigs();
  mobMenuCalc();

  mobTextFirst.forEach( (sect) => {
    sect.querySelector('.pics').classList.add('order-xs-2', 'order-md-1');
    sect.querySelector('.text-content').classList.add('order-xs-1', 'order-md-2');
  } );
});